import React from "react";
import NewsForm from "../../features/news/ui/components/NewsForm";
import createNews from "../../features/news/usecases/createNews";
import { toast } from "react-hot-toast";

const AddNews = () => {
  const handleCreate = async (data) => {
    try {
      await createNews(data);
      toast.success("Noticia agregada");
    } catch (err) {
      console.error(err);
      toast.error(err?.message || "Error al crear noticia");
    }
  };

  return (
    <section>
      <NewsForm mode="create" onSubmit={handleCreate} />
    </section>
  );
};

export default AddNews;
